// @flow

export const getMetadataFor = (meta: string, doc: Document = document): * => {
  const elem = doc.querySelector(`[${meta}]`);
  const solMetadata = elem ? elem.getAttribute(meta) : null;
  return solMetadata ? JSON.parse(solMetadata) : null;
};
